/**
 * 这里直接在index.html 和 share.html 中引入了cdn地址。如果项目中不需要，可以注释掉，避免多余资源加载
 * 需要使用其他方法，可在仓库中查找
 * http://git.in.codoon.com/fxd/NativeJs/blob/master/index.html
 */
import { shareOption } from '../lib/config.js'

const CodoonNativeBridge = window.codoonNativeBridge
const bridge = new CodoonNativeBridge()

// 分享渠道
const shareDestination = {
  'codoonTimeline': true,
  'codoonGroup': true,
  'weixinToFriend': true,
  'weixinToTimeline': true,
  'sinaWeibo': false,
  'tencentQQ': false,
  'tencentQzone': false
}

// 按钮分享
export const goSharefriend = (callback) => {
  console.log(shareOption)
  bridge.nativeCustomerShare({
    sCodoonShareImgUrl: shareOption.img,
    sCodoonShareLineLink: shareOption.link,
    sCodoonShareCodoonLineLink: shareOption.codoonLink,
    sCodoonShareDescContent: shareOption.des,
    sCodoonShareTitle: shareOption.title,
    sCodoonAnalyticsShareSource: '乐活动',
    oCodoonShareDestination: shareDestination
  })

  shareCb(() => {
    window._hmt.push(['_trackEvent', '2019超霸活动', 'click', '按钮分享按钮点击'])
    callback && callback()
  })
}

// 顶部分享
export const commonShare = (callback) => {
  bridge.nativeTopButtonShare({
    sCodoonShareImgUrl: shareOption.img,
    sCodoonShareLineLink: shareOption.link,
    sCodoonShareCodoonLineLink: shareOption.codoonLink,
    sCodoonShareDescContent: shareOption.des,
    sCodoonShareTitle: shareOption.title,
    sCodoonAnalyticsShareSource: '乐活动',
    oCodoonShareDestination: shareDestination
  })
  shareCb(() => {
    window._hmt.push(['_trackEvent', '2019超霸活动', 'click', '顶部分享'])
    callback && callback()
  })
}

// 分享后回调
export const shareCb = (callback) => {
  bridge.nativeShareClickCallback(function (err, response) {
    if (err) return alert(err)
    callback && callback()
  })
}

// 是否在app内
export const isInCodoon = () => {
  // if (window.location.href.indexOf('localhost') !== -1) {
  // return true
  // }
  return bridge.isInCodoon()
}

// 跳地址组件
export const jumpToAddressNew = (eventid, callback = function () {}) => {
  bridge.jumpToAddressManageNew(eventid, callback)
}

// 跳外链
export const jumpToUrl = (url) => {
  bridge.jumpNative({
    type: 'webView',
    value: url
  }, () => {})
}

// 跳转至话题
export const jumpToDiscuss = (id, callback) => {
  bridge.jumpNative({
    type: 'webView',
    value: `codoon://www.codoon.com/feed/feedlabel?label_id=${id}`
  }, callback)
}

// 上传图片
export const nativeUploadImgs = (file, callback) => {
  return bridge.uploadUpai(file, callback)
}

// 跳 Native 页面
export const jumpNative = (options, callback) => {
  return bridge.jumpNative(options, callback)
}

// 下载图片
export const downloadImg = (_url) => {
  return bridge.nativeDownloadImg({
    urls: [_url]
  }, (res) => {
    // console.log(res)
  })
}

// 获取gps
export const getGps = (cb) => {
  return bridge.nativeGetGps(cb)
}

/**
 * @name 站外下载咕咚
 * @params { activityUrl: 活动链接 }
**/
export const downApp = (activityUrl = 'https://www.codoon.com/activity/v2/huawei_codoon_run/index.html') => {
  const rdUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.codoon.gps&android_scheme=' +
    'codoon://www.codoon.com/outer/web_view?url=' + encodeURIComponent(activityUrl) +
    '&ios_scheme=codoon://www.codoon.com/outer/web_view?url=' + encodeURIComponent(activityUrl)
  window.location.href = rdUrl
}

export const jumpRun = (path) => {
  // path : https://www.codoon.com/activity/v2/maopujiu-race-3.0-rt/index.html
  let url = 'codoon://www.codoon.com/sport/preview?sportType=1&redirectURL=codoon://www.codoon.com/codoon/web_view?url=' + encodeURIComponent(path)
  jumpToUrl(url, () => {
    // this.$store.dispatch('getUserInfo')
  })
}
